import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import Filters from 'views/customers/financial/bankAccounts/filter'; // Importing Filters component
import Table from 'views/customers/financial/bankAccounts/table'; // Importing Table component
import Details from 'views/customers/financial/bankAccounts/details'; // Importing Details component
import Record from 'views/customers/financial/bankAccounts/record'; // Importing Record component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the bank accounts view.
 * @extends JetView
 */
export default class bankAccountsView extends JetView {
    /**
     * Configures the layout of the bank accounts view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Right section containing the Record component
        const right = {
            type: 'wide',
            rows: [Record],
        };

        // Toolbar configuration with pagination
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetch from configuration
                },
            ],
        };

        // Left section containing filters, table, and toolbar
        const left = {
            height: 600,
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label',
                            label: _('Cuentas Bancarias'), // Localized label for "Bank Accounts"
                            width: 300,
                        },
                    ],
                },
                Filters, // Including the Filters component
                Table, // Including the Table component
                toolbar, // Including the toolbar with pagination
            ],
        };

        webix.ui.fullScreen(); // Setting the UI to full screen mode

        // Returning the main layout configuration
        return {
            type: 'wide',
            cols: [left], // Main layout with left section
        };
    }
}

// FILE DOCUMENTED
